import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchAssignableApplicationsForDepartment, assignApplicationToDepartment } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import BuildDepartmentDrawer from "../../components/build/BuildDepartmentDrawer";

export default function BuildDepartmentApplicationAssignPage() {
  const { businessDomainId, businessUnitId, departmentId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assigning, setAssigning] = useState(false);

  const listPath = `/build/${businessDomainId}/business-units/${businessUnitId}/departments/${departmentId}/applications`;

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchAssignableApplicationsForDepartment(departmentId);
      setRows(Array.isArray(data) ? data : []);
    } catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleAssign = async (appCat) => {
    setAssigning(true);
    try {
      await assignApplicationToDepartment(departmentId, appCat);
      notify.success(t("message.assign.success"));
      navigate(listPath, { replace: true });
    } catch (e) { notify.apiError(e); }
    finally { setAssigning(false); }
  };

  const columns = [
    { field: "applicationCategoryName", headerName: t("applicationCategory.name"), flex: 1, minWidth: 200 },
    {
      field: "_actions",
      headerName: "",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Button
          size="small"
          variant="contained"
          disabled={assigning}
          onClick={(e) => { e.stopPropagation(); handleAssign(params.row); }}
        >
          {t("common.assign")}
        </Button>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <BuildDepartmentDrawer />
          <Typography variant="h6">{t("build.department.application.assign.title")}</Typography>
        </Box>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(r) => r.applicationCategoryId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        disableRowSelectionOnClick
        sx={{ "& .MuiDataGrid-row": { cursor: "default" } }}
      />
      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(`/build/${businessDomainId}/business-units/${businessUnitId}/departments/${departmentId}/applications`)}>{t("common.back")}</Button>
      </Box>
    </Box>
  );
}
